import { render, staticRenderFns } from "./ClientManagerSideBar.vue?vue&type=template&id=55cdcde0&"
import script from "./ClientManagerSideBar.vue?vue&type=script&lang=js&"
export * from "./ClientManagerSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports